import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const HtmlTooltip = ({ children, title, ...props }) => {
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "white",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#fff",
      color: "#505050",
      maxWidth: "420px",
      padding: "14px 24px",
      borderRadius: "10px",
    },
  }));

  return (
    <StyledTooltip title={title} {...props}>
      {children}
    </StyledTooltip>
  );
};

export default HtmlTooltip;
